import { ObjectLike } from '@/types/objectlike.types';
import {
  iGame, iGenre, iTheme, iPlatform, iImage, iInvolvedCompany, iCompany, iCover,
} from './game.types';
import { Cover } from './cover';

export class Game implements iGame {
  id: number;

  name: string;

  summary: string;

  slug: string;

  parentGame?: number | undefined;

  firstReleaseDate: number;

  genres: iGenre[];

  themes: iTheme[];

  platforms: iPlatform[];

  storyline: string;

  keywords: string[];

  cover?: iCover;

  artworks: iImage[];

  involvedCompanies: iInvolvedCompany[];

  constructor(game: ObjectLike) {
    this.id = game.id;
    this.name = game.name;
    this.summary = game.summary;
    this.slug = game.slug;
    this.firstReleaseDate = game.firstReleaseDate;
    this.genres = game.genres;
    this.themes = game.themes;
    this.platforms = game.platforms;
    this.storyline = game.storyline;
    this.keywords = game.keywords;
    this.artworks = game.artworks;
    this.involvedCompanies = game.involvedCompanies;

    if (game.parentGame) {
      this.parentGame = game.parentGame;
    }

    if (game.cover) {
      this.cover = new Cover(game.cover);
    }
  }

  get developer(): iCompany {
    const data = this.involvedCompanies.find((company) => company.developer);
    return data ? data.company : this.getEmptyCompany();
  }

  get publisher(): iCompany {
    const data = this.involvedCompanies.find((company) => company.publisher);
    return data ? data.company : this.getEmptyCompany();
  }

  get isDLC(): boolean {
    return !!this.parentGame;
  }

  private getEmptyCompany() {
    return {
      id: 0,
      name: '',
      slug: '',
      description: '',
    };
  }
}
